module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/product4.bf3c5457.png";